import {
  CogIcon, Filter, Loading2,
} from 'assets/icons/index.js';
import AdminSearchBar from 'components/AdminSearch/AdminSearchBar';
import AdminSearchInput from 'components/AdminSearch/AdminSearchInput';
import SearchTypeSelect from 'components/AdminSearch/SearchTypeSelect';
import { VIVIER_SEARCH_OPTIONS } from 'components/AdminSearch/adminSearchOptions';
import {
  VIVIER_COLUMNS_DEFAULT,
  VIVIER_COLUMNS_STORAGE_KEY,
} from 'components/modal/dataModal/data/modalVivier/ModalCustomizeVivierColumns';
import axios from 'axios';
import Button from 'components/button/index.js';
import Badge from 'components/badge/badge.js';
import useModal from 'components/modal/useModal.js';
import Pagination from 'components/pagination/pagination.js';
import UseContext from 'hooks/useContext.js';
import { useEffect, useState, useRef } from 'react';
import ApiDatabase from 'server';
import TableVivier from './components/table.vivier.js';
import FilterPanel from './components/FilterPanel.vivier.js';
import SelectionBar from './components/SelectionBar.vivier.js';
import SubNavbar from '../../../../../components/SubNavbar/SubNavbar.js';
import MediaQuery from 'react-responsive';
import BottomSheet from '../../../../../components/bottomSheet/BottomSheet';
import { dateWordShort } from '../../../../../helper/helper';
import {
  applyPatchToListRow,
  findPatchForUser,
  toUserIdString,
} from '../../../../../utils/vivierUserPatch';

const FILTER_CONFIGS = {
  activity: {
    label: 'Activité',
    type: 'select',
    options: [
      { value: 'active_today', label: "Actif aujourd'hui" },
      { value: 'active_week', label: 'Actif cette semaine' },
      { value: 'no_activity_7', label: 'Aucune activité depuis 7 jours' },
      { value: 'no_activity_10', label: 'Aucune activité depuis 10 jours' },
      { value: 'no_activity_30', label: 'Aucune activité depuis 30 jours' },
      { value: 'no_activity_90', label: 'Aucune activité depuis 90 jours' },
    ],
  },
  source: { label: 'Source candidat', type: 'select', options: [] },
  department: { label: 'Département - Ville', type: 'selectMultipleCheckbox', placeholder: 'Sélectionner un département', options: [] },
  os: { label: 'OS', type: 'toggle', options: [{ value: 'web', label: 'Web' }, { value: 'app', label: 'App' }] },
  rating: { label: 'Évaluation moyenne', type: 'rating' },
  vivier: { label: 'Vivier', type: 'selectMultipleCheckbox', placeholder: 'Sélectionner un vivier', options: [] },
  cv: { label: 'CV', type: 'toggle', options: [{ value: 'exists', label: 'Existe' }, { value: 'not_exists', label: "N'existe pas" }], exclusive: true },
  registrationDate: { label: "Date d'inscription", type: 'dateRange' },
  archived: { label: 'Archivé', type: 'toggle', options: [{ value: true, label: 'Oui' }, { value: false, label: 'Non' }], exclusive: true },
};

function BodyVivier() {
  const token = localStorage.getItem('xsrfToken');
  const { toggle } = useModal();
  const { setInfoVivier, usersVivier, setUsersVivier, setModalData, modalDataReturn } = UseContext();

  const [activeColumns, setActiveColumns] = useState(() => {
    try {
      const saved = localStorage.getItem(VIVIER_COLUMNS_STORAGE_KEY);
      return saved ? JSON.parse(saved) : VIVIER_COLUMNS_DEFAULT;
    } catch {
      return VIVIER_COLUMNS_DEFAULT;
    }
  });

  const [search, setSearch] = useState('');
  const [optionSearch, setOptionSearch] = useState('');
  const [selectProfil, setSelectProfil] = useState(false);
  const [isWaiting, setIsWaiting] = useState(true);
  const [sortName, setSortName] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const limitElement = 25;
  const [totalPages, setTotalPages] = useState(0);
  const [countPerPage, setCountPerPage] = useState(0);
  const [countTotal, setCountTotal] = useState(0);
  const [result, setResult] = useState();
  const [listAddVivier, setAddVivier] = useState([]);

  const [isFilterPanelOpen, setIsFilterPanelOpen] = useState(false);
  const [expandedFilter, setExpandedFilter] = useState(null);
  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [vivierOptions, setVivierOptions] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);
  const [sourceOptions, setSourceOptions] = useState([]);
  const filterListRef = useRef(null);

  const buildDefaultDeptFilter = (depts) => [
    ...depts.map((d) => ({ value: d.toLowerCase(), label: d, checked: false })),
    { value: 'other', label: 'Aucun', checked: false },
  ];

  const [defaultFilterValues, setDefaultFilterValues] = useState({
    department: [{ value: 'other', label: 'Aucun', checked: false }],
    os: { web: false, app: false },
  });
  const [filterValues, setFilterValues] = useState(defaultFilterValues);
  const [filterApplyTrigger, setFilterApplyTrigger] = useState(0);

  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [tempSearch, setTempSearch] = useState('');
  const [tempOptionSearch, setTempOptionSearch] = useState('');

  const openFilterSheet = () => {
    setTempSearch(search);
    setTempOptionSearch(optionSearch);
    setIsFilterOpen(true);
  };

  const applyMobileFilters = () => {
    setSearch(tempSearch);
    setOptionSearch(tempOptionSearch);
    setIsFilterOpen(false);
  };

  useEffect(() => {
    ApiDatabase.getVivierAll({}, (data) => {
      setVivierOptions(data.map((v) => ({ value: v._id, label: v.name })));
    }, () => {});

    axios.get(`${process.env.REACT_APP_API_URL}registrationSource`)
      .then(({ data }) => setSourceOptions(data.map((s) => ({ value: s._id, label: s.name }))))
      .catch(() => {});

    ApiDatabase.getCityDepartments(
      { token },
      (data) => {
        const opts = [...data.map((d) => ({ value: d.toLowerCase(), label: d })), { value: 'other', label: 'Aucun' }];
        setDepartmentOptions(opts);
        const deptDefaults = buildDefaultDeptFilter(data);
        setDefaultFilterValues((prev) => ({ ...prev, department: deptDefaults }));
        setFilterValues((prev) => ({ ...prev, department: deptDefaults }));
      },
      () => {}
    );
  }, []);

  const selectedDepartments = (filterValues.department || [])
    .filter((d) => d.checked && d.value !== 'other')
    .map((d) => d.value);

  useEffect(() => {
    if (selectedDepartments.length === 0) {
      setCityOptions([]);
      setFilterValues((prev) => ({ ...prev, city: [] }));
      return;
    }
    ApiDatabase.getCitiesByDepartments(
      { token, departments: JSON.stringify(selectedDepartments) },
      (data) => {
        const opts = data.map((c) => ({ value: c.name, label: c.name, checked: false }));
        setCityOptions(opts);
        setFilterValues((prev) => {
          const prevCities = prev.city || [];
          const validValues = new Set(opts.map((o) => o.value));
          const kept = prevCities.filter((c) => c.checked && validValues.has(c.value));
          return { ...prev, city: opts.map((o) => ({ ...o, checked: kept.some((k) => k.value === o.value) })) };
        });
      },
      () => {}
    );
  }, [selectedDepartments.join(',')]);

  const resolvedFilterConfigs = {
    ...FILTER_CONFIGS,
    department: { ...FILTER_CONFIGS.department, options: departmentOptions },
    source: { ...FILTER_CONFIGS.source, options: sourceOptions },
    vivier: { ...FILTER_CONFIGS.vivier, options: vivierOptions },
  };

  const manageCandidatSearch = () => {
    setIsWaiting(true);
    const { vivier: vivierList, department: deptList, city: cityList, ...otherFilterValues } = filterValues;
    const checkedVivierIds = (vivierList || []).filter((v) => v.checked).map((v) => v.value);
    const checkedDeptIds = (deptList || []).filter((v) => v.checked).map((v) => v.value);
    const checkedCityNames = (cityList || []).filter((v) => v.checked).map((v) => v.value);

    const rawFilterOptions = {
      ...otherFilterValues,
      ...(checkedVivierIds.length > 0 ? { vivier: checkedVivierIds } : {}),
      ...(checkedDeptIds.length > 0 ? { department: checkedDeptIds } : {}),
      ...(checkedCityNames.length > 0 ? { city: checkedCityNames } : {}),
    };
    const filterOptions = Object.fromEntries(
      Object.entries(rawFilterOptions).filter(([, val]) => {
        if (val === null || val === undefined) return false;
        if (Array.isArray(val)) return val.length > 0;
        if (typeof val === 'object') return Object.values(val).some(Boolean);
        return true;
      })
    );

    ApiDatabase.getVivierListUsers(
      { token, page: currentPage, limit: limitElement, search, optionSearch, profil: selectProfil, filterOptions: JSON.stringify(filterOptions) },
      (data) => {
        setTotalPages(data.countPages);
        setCountPerPage(limitElement);
        setCountTotal(data.count);
        setResult(data.users);
        setIsWaiting(false);
      },
      (error) => { if (error?.name !== 'CanceledError') { console.error(error); setIsWaiting(false); } }
    );
  };

  useEffect(() => { setCurrentPage(1); }, [search, optionSearch, filterApplyTrigger, limitElement, selectProfil]);

  useEffect(() => {
    const timer = setTimeout(manageCandidatSearch, 400);
    return () => clearTimeout(timer);
  }, [search, optionSearch, sortName, currentPage, selectProfil, filterApplyTrigger, limitElement]);

  const activeFilterCount = Object.keys(filterValues).filter((k) => {
    if (k === 'city') return false;
    const val = filterValues[k];
    if (val === null || val === undefined) return false;
    if (k === 'department') {
      return (val || []).some((item) => item.checked) || (filterValues.city || []).some((item) => item.checked);
    }
    if (Array.isArray(val)) return val.some((item) => item.checked);
    if (typeof val === 'object') return Object.values(val).some(Boolean);
    return true;
  }).length;

  const setFilterValue = (key, value) => setFilterValues((prev) => ({ ...prev, [key]: value }));
  const clearFilterValue = (key) => setFilterValues((prev) => { const next = { ...prev }; delete next[key]; return next; });

  const getFilterDisplayValue = (filterKey) => {
    const value = filterValues[filterKey];
    const config = resolvedFilterConfigs[filterKey];
    if (value === null || value === undefined || !config) return null;

    if (config.type === 'toggle' && config.exclusive) return config.options.find((o) => o.value === value)?.label || value;
    if (config.type === 'toggle') {
      const active = config.options.filter((o) => value[o.value] !== false).map((o) => o.label);
      return active.join(', ') || null;
    }
    if (config.type === 'select') return (config.options.length > 0 ? config.options.find((o) => o.value === value)?.label : value) || value;
    if (config.type === 'selectMultipleCheckbox') {
      const checked = (value || []).filter((v) => v.checked);
      if (filterKey === 'department') {
        const checkedCities = (filterValues.city || []).filter((v) => v.checked);
        if (!checked.length && !checkedCities.length) return null;
        const parts = [];
        if (checked.length) parts.push(checked.map((v) => v.label).join(', '));
        if (checkedCities.length) parts.push(checkedCities.map((v) => v.label).join(', '));
        return parts.join(' · ');
      }
      return checked.length ? checked.map((v) => v.label).join(', ') : null;
    }
    if (config.type === 'dateRange') {
      if (!value || (!value.start && !value.end)) return null;
      if (value.start && value.end) return `${dateWordShort(value.start)} → ${dateWordShort(value.end)}`;
      return value.start ? `Depuis ${dateWordShort(value.start)}` : `Jusqu'au ${dateWordShort(value.end)}`;
    }
    if (config.type === 'rating') {
      if (value.min && value.max) return `${value.min}-${value.max} étoiles`;
      if (value.min) return `Min ${value.min}`;
      if (value.max) return `Max ${value.max}`;
      return null;
    }
    return null;
  };

  const sortedFilterKeys = Object.keys(resolvedFilterConfigs).sort((a, b) => {
    const aActive = getFilterDisplayValue(a) !== null;
    const bActive = getFilterDisplayValue(b) !== null;
    if (aActive && !bActive) return -1;
    if (!aActive && bActive) return 1;
    return 0;
  });

  const handleAction = (modalType) => {
    setInfoVivier({ listUsers: listAddVivier });
    toggle(modalType);
  };

  useEffect(() => {
    if (!usersVivier?.length) return;
    if (!result?.length) return;

    const deletedIds = new Set(
      usersVivier.filter((u) => u._deleted).map((u) => toUserIdString(u.id_user))
    );

    const updatedResult = result
      .map((row) => {
        if (deletedIds.has(toUserIdString(row._id))) return null;
        const patch = findPatchForUser(usersVivier, row._id);
        return patch ? applyPatchToListRow(row, patch) : row;
      })
      .filter(Boolean);

    setResult(updatedResult);
    setUsersVivier([]);
    setInfoVivier({ listUsers: [] });
    setAddVivier([]);
  }, [usersVivier]);

  useEffect(() => {
    if (!expandedFilter) return;
    const handleClickOutside = (e) => {
      if (filterListRef.current && !filterListRef.current.contains(e.target)) setExpandedFilter(null);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [expandedFilter]);

  useEffect(() => {
    if (modalDataReturn?.type === 'vivier_columns_updated') {
      setActiveColumns(modalDataReturn.activeColumns);
    }
  }, [modalDataReturn]);

  return (
    <div className="flex flex-col h-full overflow-hidden">
      <SubNavbar>
        <div className="flex justify-between items-center w-full gap-3">
          <MediaQuery minWidth={768}>
            <div className="flex gap-3 items-center">
              <AdminSearchBar
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder="Rechercher dans le CV.."
                optionValue={optionSearch}
                onOptionChange={setOptionSearch}
                searchOptions={VIVIER_SEARCH_OPTIONS}
                showTypeSelect
                inputWrapperClassName="w-[320px]"
                selectWrapperClassName="w-[140px]"
                selectClassName="rounded-lg"
              />
            </div>
            <div className="flex items-center gap-2">
              <Button
                size="ICON"
                color="SECONDARY"
                onClick={() => {
                  setModalData({ activeColumns });
                  toggle('vivier_customize_columns');
                }}
              >
                <CogIcon wh={20} color="#374151" />
              </Button>
              <Button color="SECONDARY" size="SM" onClick={() => setIsFilterPanelOpen(true)}>
                <Filter wh={16} color="#374151" />
                <span>Plus de filtres</span>
                {activeFilterCount > 0 && <Badge type="WARNING">{activeFilterCount}</Badge>}
              </Button>
            </div>
          </MediaQuery>

          <MediaQuery maxWidth={767}>
            <div className="flex gap-3 items-center flex-1">
              <div className="flex-1">
                <AdminSearchInput
                  placeholder="Rechercher..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>
            </div>
            <Button color="SECONDARY" size="SM" onClick={openFilterSheet}>
              <Filter wh={16} color="#374151" />
              <span>Filtrer</span>
              {activeFilterCount > 0 && <Badge type="WARNING">{activeFilterCount}</Badge>}
            </Button>
          </MediaQuery>
        </div>
      </SubNavbar>

      <div className="flex flex-col w-full h-full overflow-hidden">
        <div className="flex-1 overflow-auto">
          {isWaiting ? (
            <div className="flex justify-center items-center h-80">
              <div className="animate-spin">
                <Loading2 wh={50} color="#FF9600" />
              </div>
            </div>
          ) : (
            <div className="h-full">
              <TableVivier
                users={result}
                setSortName={setSortName}
                sortName={sortName}
                setAddVivier={setAddVivier}
                list={listAddVivier}
                activeColumns={activeColumns}
                sourceOptions={sourceOptions}
              />
            </div>
          )}
        </div>

        {!isWaiting && totalPages > 1 && (
          <div className="flex-shrink-0 border-t border-gray-100 bg-white px-8 py-4">
            <Pagination
              currentPage={currentPage}
              countPerPage={countPerPage}
              countTotal={countTotal}
              totalPages={totalPages}
              setCurrentPage={setCurrentPage}
            />
          </div>
        )}

        <SelectionBar
          count={listAddVivier.length}
          onAddVivier={() => handleAction('vivier_add')}
          onChangeLocalisation={() => handleAction('localisation_preferences')}
          onExclude={() => handleAction('exclude_agency')}
        />
      </div>

      <FilterPanel
        isOpen={isFilterPanelOpen}
        onClose={() => setIsFilterPanelOpen(false)}
        filterConfigs={resolvedFilterConfigs}
        filterValues={filterValues}
        sortedFilterKeys={sortedFilterKeys}
        expandedFilter={expandedFilter}
        setExpandedFilter={setExpandedFilter}
        getFilterDisplayValue={getFilterDisplayValue}
        setFilterValue={setFilterValue}
        clearFilterValue={clearFilterValue}
        cityOptions={cityOptions}
        filterListRef={filterListRef}
        onReset={() => { setFilterValues(defaultFilterValues); setExpandedFilter(null); setFilterApplyTrigger((p) => p + 1); }}
        onApply={() => { setIsFilterPanelOpen(false); setExpandedFilter(null); setFilterApplyTrigger((p) => p + 1); }}
        activeFilterCount={activeFilterCount}
      />

      <BottomSheet isOpen={isFilterOpen} onClose={() => setIsFilterOpen(false)} title="Filtrer">
        <div className="flex flex-col gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Rechercher</label>
            <AdminSearchInput
              placeholder="Rechercher..."
              value={tempSearch}
              onChange={(e) => setTempSearch(e.target.value)}
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Rechercher par</label>
            <SearchTypeSelect
              value={tempOptionSearch}
              onChange={setTempOptionSearch}
              options={VIVIER_SEARCH_OPTIONS}
              className="rounded-lg"
            />
          </div>
          <div className="mt-2">
            <Button color="PRIMARY" size="FULL" onClick={applyMobileFilters}>Appliquer</Button>
          </div>
        </div>
      </BottomSheet>
    </div>
  );
}

export default BodyVivier;
